<template>
  <div class="product-thumbnails">
    <div class="thumbnail" v-for="product in products" :key="product.id">
      <div class="image" :style="getImageBackground(product.product)"></div>
      <div class="price" v-if="product.product.price_formatted">{{ product.product.price_formatted }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
    /**
     * Return the current products in socket
     * @returns {Array}
     */
    products() {
      const {
        broadcast: {
          actual_start_time,
        },
      } = this;

      const videoTime = this.$store.getters['Player/currentTime'];
      const curr = new Date(actual_start_time);
      curr.setSeconds(curr.getSeconds() + videoTime);
      const prods = this.$store.getters['Products/eventProducts'].filter(p => (curr >= new Date(p.displayAt) && typeof p.hideAt === 'undefined') || (curr >= new Date(p.displayAt) && new Date(p.hideAt) >= curr));
      if (prods.length > 0) {
        const proddi = this.$store.getters['Products/broadcastProducts'];
        prods.forEach((p, index) => {
          const pi = proddi.findIndex(pr => pr.id === p.id);
          if (pi >= 0) {
            prods[index] = { ...p, product: proddi[pi] };
          }
        });
      }
      return [...prods.slice(-3)].reverse();
    },
  },
  methods: {
    getImageBackground(product) {
      const image = product.image_url || product.image;
      if (!image) {
        return '';
      }
      if (image.includes('http')) {
        return `backgroundImage: url('${image}')`;
      }

      return `backgroundImage: url('https://${this.broadcast.fqdn}/images/h/90/${image}')`;
    },
  },
};
</script>

<style lang="scss">
.product-thumbnails {

  &[data-orientation="portrait"] {
    position: absolute;
    left: 20px;
    top: 70px;

    .thumbnail {
      margin-bottom: 2px;
    }
  }

  &[data-orientation="landscape"] {
    display: flex;
    position: absolute;
    bottom: 50px;
    right: 20px;

    .thumbnail {
      margin-left: 2px;
    }
  }

  .thumbnail {
    background-color: white;
    width: 72px;
    height: 72px;
    display: block;
    transition: all .3s;
    pointer-events: all;
    z-index: 10;
    position: relative;

    .image {
      width: 100%;
      height: 72px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      transition: all .3s;
    }

    .price {
      white-space: nowrap;
      position: absolute;
      padding-left: 3px;
      padding-right: 3px;
      bottom: 0;
      right: 0;
      font-size: 10px;
      line-height: 16px;
      background-color: black;
      color: white;
    }
  }
}
</style>
